module.exports = __webpack_public_path__ + "9b274e38721986f0c56965138d05054f.png";